import { render, staticRenderFns } from "./SubpageMessageDetail.vue?vue&type=template&id=5c7f2c00&scoped=true&"
import script from "./SubpageMessageDetail.vue?vue&type=script&lang=js&"
export * from "./SubpageMessageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f2c00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7f2c00')) {
      api.createRecord('5c7f2c00', component.options)
    } else {
      api.reload('5c7f2c00', component.options)
    }
    module.hot.accept("./SubpageMessageDetail.vue?vue&type=template&id=5c7f2c00&scoped=true&", function () {
      api.rerender('5c7f2c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/outagecenter/SubpageMessageDetail.vue"
export default component.exports